import { Interaction, StoreInteractionRequest } from "../../@types/Interaction";
import { api } from "../api";

export default async function store(
  dto: StoreInteractionRequest
): Promise<Interaction | null> {
  try {
    const { data, status } = await api.post("/interaction", dto);

    if (status === 201) {
      return data;
    }

    return null;
  } catch (err) {
    console.log(err);

    return null;
  }
}
